import { DateHelper } from '@helpers/date.helper';
import { Contributor, ContributorJson } from '@models/contributor';

export interface CreationFormalityAbandonJson {
  is_abandoned?: boolean;
  reason?: string;
  comment?: string;
  abandoned_by?: ContributorJson;
  abandoned_at?: string;
}

export class CreationFormalityAbandon {
  constructor(
    public isAbandoned?: boolean,
    public reason?: string,
    public comment?: string,
    public abandonedBy?: Contributor,
    public abandonedAt?: Date
  ) {}

  static fromJson(json: CreationFormalityAbandonJson): CreationFormalityAbandon {
    return new CreationFormalityAbandon(
      json.is_abandoned,
      json.reason,
      json.comment,
      json.abandoned_by ? Contributor.fromJson(json.abandoned_by) : null,
      json.abandoned_at ? DateHelper.fromUtc(json.abandoned_at) : null
    );
  }

  static toJson(abandon: CreationFormalityAbandon): CreationFormalityAbandonJson {
    return {
      is_abandoned: abandon.isAbandoned,
      reason: abandon.reason,
      comment: abandon.comment
    };
  }
}
